import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PssAuthService } from '../../services/pss-auth.service';
import { PssAccount } from '../../models/pss-account.model';

@Component({
  selector: 'app-account-picker',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './account-picker.component.html',
  styleUrls: ['./account-picker.component.css']
})
export class AccountPickerComponent implements OnInit {
  accounts: PssAccount[] = [];
  loadingId: string | null = null;
  error = '';

  constructor(private auth: PssAuthService, private router: Router) {}

  ngOnInit() {
    this.auth.getSavedAccounts().subscribe({
      next: accounts =>
        this.accounts = accounts.sort((a, b) =>
          b.lastLogin.localeCompare(a.lastLogin)
        ),
      error: () =>
        this.error = 'Could not reach account server. Is it running?'
    });
  }

  select(account: PssAccount) {
    this.loadingId = account.userId;
    this.error = '';
    this.auth.loginWithAccount(account).subscribe({
      next: () => this.router.navigate(['/dashboard']),
      error: err => {
        this.loadingId = null;
        const msg = err?.error?.error ?? err?.message ?? 'Login failed';
        this.error = msg === 'Account is locked'
          ? `Your account has been locked. Please contact an admin.`
          : `Failed to log in as ${account.name}: ${msg}`;
      }
    });
  }

  remove(account: PssAccount, event: MouseEvent) {
    event.stopPropagation();
    this.auth.removeAccount(account.userId).subscribe(() => {
      this.accounts = this.accounts.filter(a => a.userId !== account.userId);
    });
  }

  addAccount() {
    this.router.navigate(['/login']);
  }
}
